import { useDebouncedValue } from "@/common/hooks/useDebouncedValue";

const AMOUNT_DEBOUNCE_MS = 300;

export const useTipSuggestionsQueryTrigger = ({
  tipBaseAmount,
  displayedFormAmount,
  isPaymentStep,
  hasDonorChangedAmount,
}: {
  tipBaseAmount: number;
  displayedFormAmount: number;
  isPaymentStep: boolean;
  hasDonorChangedAmount: boolean;
}): { tipBaseAmount: number; formAmount: number; isTriggered: boolean } => {
  const debouncedTipBaseAmount = useDebouncedValue(tipBaseAmount, AMOUNT_DEBOUNCE_MS);
  const debouncedFormAmount = useDebouncedValue(displayedFormAmount, AMOUNT_DEBOUNCE_MS);

  if (isPaymentStep) {
    return { tipBaseAmount, formAmount: displayedFormAmount, isTriggered: true };
  }

  return { tipBaseAmount: debouncedTipBaseAmount, formAmount: debouncedFormAmount, isTriggered: hasDonorChangedAmount };
};
